import Request from "./index";

class api {
  //【前台】获取共享资源列表（分页）
  static getSharePage(data) {
    return Request.get("/resource/share/page", {
      params: data
    });
  }

  //【前台】获取共享资源列表（按点击量获取）（分页）
  static getPageByClick(data) {
    return Request.get("/resource/order_click/page", {
      params: data
    });
  }

  // 增加资源点击量
  static addResourceClick(id) {
    return Request.put("/resource/clicks/" + id);
  }

  //【前台】获取跨平台共享资源列表（分页）
  static getCrossShareList(data) {
    return Request.get("/resource/cross/share/page", {
      params: data
    });
  }

  //【前台】获取跨平台共享资源列表（按点击量获取）（分页）
  static getCrossPageByClick(data) {
    return Request.get("/resource/cross/order_click/page", {
      params: data
    });
  }
}

export default api;
